module.exports = {
    bindings: {
        translation: '<'
    },
    templateUrl: 'widgets/components/translated-text.html'
};